import { post } from "../../static/axios";
import { Dialog, Toast } from 'vant';
import router from "../router";
import Store from '../store'

export class Login{
  static getAuthToken(data){
    return post('/app-user/getAuthToken',data)
  }
  static getPhoneWithToken(data){
    return post('/app-user/getPhoneWithToken',data)
  }
  static login(data){
    return post('/app-user/login',data)
  }
  //注销
  static logOff(data){
    return post('/app-user/logOff',data)
  }
  //调度注册
  static addDispatch(data) {
    return post('/app-register/addDispatch', data)
  }
  //司机注册
  static addRegister(data) {
    return post('/app-register/addRegister', data)
  }
  //更改头像
  static profileUpdate(data) {
    return post('/app-register/profileUpdate', data)
  }
  //更改昵称
  static nickNameUpdate(data) {
    return post('/app-register/nickNameUpdate', data)
  }
  //添加位置信息
  static addPosition(data){
    return post('/app-position/addPosition',data)
  }
  //添加订单轨迹位置信息
  static orderTracksSave(data){
    return post('/app-order/orderTracksSave',data)
  }
  //添加token信息
  static UpdateToken(data){
    return post('/app-user/UpdateToken',data)
  }
  //待命司机查询接口
  static queryWaitingDrivers(data){
    return post('/app-position/queryWaitingDrivers',data)
  }
  //订单对应司机的位置查询接口
  static getPosition(data){
    return post('/app-position/getPosition',data)
  }
  //订单对应司机的位置轨迹查询接口
  static orderTracksQry(data){
    return post('/app-order/orderTracksQry',data)
  }
  static driverDetail(data){
    return post('/app-promotion/driverDetail ',data)
  }
  // 判断手机号有无登陆
  static async verifyLogin(showModal = true){
    const phone = localStorage.getItem('phone')
    if (!phone && showModal) {
      let res =await Dialog.confirm({
        title: '登录',
        message: '还未登录，请先登录',
      })
      if (res) {
        router.push({
          path:'/login'
        })
      }
      
    }

    return Boolean(phone)
  }
  static async delete() {
    let res = await Dialog.confirm({
      title: '提示',
      message: '确定注销账号？',
    }).catch(() => false)

    if (res) {
      let o = {
        phone: localStorage.getItem('phone')
      }
      let r = await this.logOff({ body: o }) // 需要从正确的模块导入 logOff
      if (r.errcode == "0") {
        Toast.success(r.message)
        // 使用 Vuex action 清除用户信息
        Store.dispatch("member/clearProfile");
        Store.dispatch("member/clearIntroduceInfo");
        localStorage.clear();
        Store.dispatch("stopLocationUpdate");
        router.push({
          path: '/login'
        })
      }
    }
  }
  // 退出登录
  static async out(){
    let res = await Dialog.confirm({
      title: '提示',
      message: '确定退出登录？',
    })
    if (res) {
      // 使用 Vuex action 清除用户信息
      Store.dispatch("member/clearProfile");
      Store.dispatch("member/clearIntroduceInfo");
      localStorage.clear();
      Store.dispatch("stopLocationUpdate");
      router.push({
        path: '/login'
      })
    }
  }

}
export class User {
  static queryPersonalData(data) {
    return post('/app-register/queryPersonalData', data)
  }
}


// WEBPACK FOOTER //
// ./src/api/login.js